let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bo4Sa")).then(() => parcelRequire('gnT6K'));